import { SubmissionError, change } from 'redux-form'
import { rest, isApiError } from 'services'
import { isErrorCode } from 'helpers/utils'
import { preparePhoneNumber } from 'helpers/phone-number'
import { getShoppingData } from 'actions/shoppingData'
import { sendServicesAndDateTime } from 'components/Appointment/actions'
import { getAppointments } from 'selectors/getAppointments'
import { getQueryParams } from 'selectors/getPageLocation'
import { submitAppointment } from 'components/AppointmentConfirmationPage/AppointmentInfo/actions'
import { getAppointmentFormValues } from './selectors'
import { APPOINTMENT_FORM_NAME, DATE_TIME_SELECTOR_FIELD_NAME, CODE_PLEASE_SELECT_STORE } from 'constant'
import {
  FIVE_STEPPER,
  THREE_STEPPER
} from 'components/QuickAppointmentPage/constants'
import { getPreSelectedServices } from '../../Appointment/selectors'
import { setActivePromotions } from 'components/QuickAppointmentPage/actions.js'

export const sendAppointment = setCurrentStepIndex => (dispatch, getState) => {
  const { phoneNumber, firstName, lastName, email, userPlan } = getAppointmentFormValues(getState())
  return dispatch(
    submitAppointment({
      phoneNumber,
      firstName,
      lastName,
      email,
      userPlan,
      setCurrentStepIndex,
      fromAppointmentStepper: true
    })
  )
}

export const submitAppointmentContactDetails = ({ userPlan, firstName, lastName, email, phoneNumber }, nextPageClick) =>
  dispatch => dispatch(sendServicesAndDateTime(true, true))
    .then(() =>
      dispatch(getShoppingData(rest.api.changeAppointmentContactDetails, {
        userPlan,
        firstName,
        lastName,
        email,
        ...preparePhoneNumber(phoneNumber),
        isFromOnlineAppointment: true
      })))
    .then(() => nextPageClick())
    .catch(err => {
      if (isApiError(err)) {
        throw new SubmissionError({ _error: err.status.description })
      }
    })

export const getAppointmentDatesAndSlots = ({
  fiveStepperEnabled = false,
  setSubmitAttemptFailed,
  submitAttemptFailed } = {}
) => (dispatch, getState) => {
  const state = getState()
  const {
    catalogRefIds = [],
    serviceComment = '',
    activePromotions = []
  } = getAppointmentFormValues(state)
  const { isTrailer } = getAppointments(state)
  const { promoId } = getQueryParams(state)
  const preSelectedServices = getPreSelectedServices(state)

  let requestData = {
    catalogRefIds,
    isTrailer: fiveStepperEnabled ? isTrailer : undefined,
    stepperType: fiveStepperEnabled ? FIVE_STEPPER : THREE_STEPPER
  }

  // Clearing promotions list from appointment state if user has removed promotions from Appointment form
  if (!activePromotions.length) {
    dispatch(setActivePromotions([]))
  }

  // if at least one selected service is included in the promotion service list, add promotionId to the request payload
  if (activePromotions.length && promoId && preSelectedServices
    && preSelectedServices.some(a => catalogRefIds.includes(a))) {
    requestData = {
      promotionId: promoId,
      ...requestData
    }
  }

  if (serviceComment) {
    requestData = {
      serviceComment,
      ...requestData
    }
  }

  dispatch(change(APPOINTMENT_FORM_NAME, DATE_TIME_SELECTOR_FIELD_NAME, {}))
  return dispatch(getShoppingData(rest.api.addServices, requestData))
    .catch(err => {
      if (isApiError(err)) {
        if (isErrorCode({ err, code: CODE_PLEASE_SELECT_STORE })) {
          setSubmitAttemptFailed && !submitAttemptFailed && setSubmitAttemptFailed(true)
        } else {
          throw new SubmissionError({ _error: err.status.description })
        }
      }
    })
}

export const getTAOSAppointmentDatesAndSlots = () => (dispatch) => {
  dispatch(getShoppingData(rest.api.getTAOSAppointmentDatesAndSlots, {
    isFromOnlineAppointment: true
  })).catch(err => {
    if (isApiError(err)) {
      console.error(err)
    }
  })
}
